import type { ModuleTagEntry } from './index';

/** General Study module tags. */
export const tags: ModuleTagEntry[] = [
  'StudyInstanceUID',
  'StudyDescription',
  'StudyDate',
  'StudyTime',
  'AccessionNumber',
];
